import { Fingerprint } from 'lucide-react'
import { api } from '../lib/api'
import { useResource } from '@retink/web-ui'
import { Badge } from '@retink/web-ui'
import { Card, CardHeader, Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '@retink/web-ui'
import { PageHeader } from '@retink/web-ui'
import { EmptyState, TableEmpty } from '@retink/web-ui'
import { LoadingState, ErrorState } from '@retink/web-ui'

interface IdpKind { key: string; label: string; enabled: boolean }

// The platform's catalog of identity-provider adaptors — the kinds we support as
// capabilities. These are not configured for any tenant here; organizations pick
// from this catalog to create provider instances, and tenants enable them.
export function Idp() {
  const { data: kinds = [], loading, error, reload } = useResource(() => api.get<IdpKind[]>('/api/admin/idp/kinds'), [])

  return (
    <div className="p-8">
      <PageHeader
        title="IdP Adaptors"
        description="Identity-provider kinds the platform supports. Organizations configure instances of these on their own IdP page; tenants then enable them. “Coming soon” kinds aren’t available to configure yet."
      />

      <Card className="overflow-hidden">
        <CardHeader>Available adaptors</CardHeader>
        <Table>
          <TableHeader>
            <TableRow className="hover:bg-transparent">
              {['Adaptor', 'Key', 'Availability'].map((h) => <TableHead key={h}>{h}</TableHead>)}
            </TableRow>
          </TableHeader>
          <TableBody>
            {loading && <TableEmpty colSpan={3}><LoadingState /></TableEmpty>}
            {!loading && error && <TableEmpty colSpan={3}><ErrorState message={error} onRetry={reload} /></TableEmpty>}
            {!loading && !error && kinds.length === 0 && (
              <TableEmpty colSpan={3}>
                <EmptyState
                  icon={Fingerprint}
                  title="No adaptors"
                  description="The identity-provider catalog is empty."
                />
              </TableEmpty>
            )}
            {kinds.map((k) => (
              <TableRow key={k.key}>
                <TableCell className="font-medium">{k.label}</TableCell>
                <TableCell className="font-mono text-xs text-muted-foreground">{k.key}</TableCell>
                <TableCell>
                  <Badge tone={k.enabled ? 'success' : 'neutral'}>{k.enabled ? 'Live' : 'Coming soon'}</Badge>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  )
}
